const BagIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4142 2H8.58579L6.5 4.08579V7H3V22H21V7H17.5V4.08579L15.4142 2ZM15.5 9V11H17.5V9H19V20H5V9H6.5V11H8.5V9H15.5ZM15.5 7V4.91421L14.5858 4H9.41421L8.5 4.91421V7H15.5Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default BagIcon
